/* ==========================================
   product.js — Variantes, galería, add to cart, quick view
   Dependencias: theme.js (trapFocus, shopifyFetch, showOverlay, hideOverlay)
   ========================================== */

/* ---- Product form (variant selector + add to cart) ---- */

(function() {
  var sections = document.querySelectorAll('[data-product-section]');
  sections.forEach(initProductSection);

  function initProductSection(section) {
    var productJson = section.querySelector('[data-product-json]');
    if (!productJson) return;

    var product;
    try { product = JSON.parse(productJson.textContent); }
    catch(e) { return; }

    var state = {
      product: product,
      currentVariant: null,
      options: []
    };

    var els = {
      section: section,
      form: section.querySelector('[data-product-form]'),
      variantId: section.querySelector('[data-variant-id]'),
      priceRegular: section.querySelector('[data-price-regular]'),
      priceCompare: section.querySelector('[data-price-compare]'),
      priceSale: section.querySelector('[data-price-sale]'),
      badgeSale: section.querySelector('[data-badge-sale]'),
      badgeSoldOut: section.querySelector('[data-badge-sold-out]'),
      addBtn: section.querySelector('[data-add-to-cart]'),
      addBtnText: section.querySelector('[data-add-text]'),
      sku: section.querySelector('[data-product-sku]'),
      availability: section.querySelector('[data-availability]'),
      quantityInput: section.querySelector('[data-quantity-input]'),
      optionInputs: section.querySelectorAll('[data-option-input]'),
      mainImage: section.querySelector('[data-main-image]'),
      thumbnails: section.querySelectorAll('[data-thumbnail]'),
      gallery: section.querySelector('[data-product-gallery]'),
      mobileSlider: section.querySelector('[data-mobile-slider]')
    };

    /* -- Variant selection -- */
    function getSelectedOptions() {
      var options = [];
      var optionGroups = section.querySelectorAll('[data-option-group]');
      optionGroups.forEach(function(group) {
        var selected = group.querySelector('[data-option-input]:checked') ||
                       group.querySelector('select[data-option-input]');
        if (selected) {
          options.push(selected.value);
        }
      });
      return options;
    }

    function findVariant(options) {
      return product.variants.find(function(v) {
        return v.options.every(function(opt, i) {
          return opt === options[i];
        });
      }) || null;
    }

    function onOptionChange() {
      var options = getSelectedOptions();
      var variant = findVariant(options);
      state.currentVariant = variant;

      if (variant) {
        updateURL(variant);
        updatePrice(variant);
        updateAvailability(variant);
        updateSKU(variant);
        updateGalleryImage(variant);
        updateVariantInput(variant);
      } else {
        disableAddButton(true);
      }

      document.dispatchEvent(new CustomEvent('variant:changed', {
        detail: { variant: variant, product: product }
      }));
    }

    function updateURL(variant) {
      if (!variant || !history.replaceState) return;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
    }

    function updatePrice(variant) {
      if (!variant) return;
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;

      if (els.priceRegular) {
        els.priceRegular.textContent = formatMoney(variant.price);
        els.priceRegular.hidden = onSale;
      }
      if (els.priceSale) {
        els.priceSale.textContent = formatMoney(variant.price);
        els.priceSale.hidden = !onSale;
      }
      if (els.priceCompare) {
        els.priceCompare.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
        els.priceCompare.hidden = !onSale;
      }
      if (els.badgeSale) {
        if (onSale) {
          var percent = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
          els.badgeSale.textContent = '-' + percent + '%';
          els.badgeSale.hidden = false;
        } else {
          els.badgeSale.hidden = true;
        }
      }
      if (els.badgeSoldOut) {
        els.badgeSoldOut.hidden = variant.available;
      }
    }

    function updateAvailability(variant) {
      if (!variant) return;
      if (els.addBtn) {
        els.addBtn.disabled = !variant.available;
      }
      if (els.addBtnText) {
        if (variant.available) {
          els.addBtnText.textContent = els.addBtnText.dataset.addText || 'Agregar al carrito';
        } else {
          els.addBtnText.textContent = els.addBtnText.dataset.soldOutText || 'Agotado';
        }
      }
      if (els.availability) {
        els.availability.textContent = variant.available
          ? (els.availability.dataset.inStock || 'En stock')
          : (els.availability.dataset.soldOut || 'Agotado');
        els.availability.dataset.available = variant.available;
      }
    }

    function disableAddButton(noVariant) {
      if (els.addBtn) els.addBtn.disabled = true;
      if (els.addBtnText) {
        els.addBtnText.textContent = els.addBtnText.dataset.unavailableText || 'No disponible';
      }
    }

    function updateSKU(variant) {
      if (!els.sku || !variant) return;
      els.sku.textContent = variant.sku || '';
    }

    function updateVariantInput(variant) {
      if (els.variantId && variant) {
        els.variantId.value = variant.id;
      }
    }

    function updateGalleryImage(variant) {
      if (!variant || !variant.featured_image) return;
      var imageId = variant.featured_image.id;

      /* Update main image */
      if (els.mainImage && imageId) {
        var newSrc = variant.featured_image.src;
        var sized = getSizedImageUrl(newSrc, '900x');
        els.mainImage.src = sized;
        els.mainImage.srcset = getSizedImageUrl(newSrc, '450x') + ' 450w, ' +
                                getSizedImageUrl(newSrc, '700x') + ' 700w, ' +
                                getSizedImageUrl(newSrc, '900x') + ' 900w, ' +
                                getSizedImageUrl(newSrc, '1200x') + ' 1200w';
        els.mainImage.alt = variant.featured_image.alt || product.title;
      }

      /* Highlight matching thumbnail */
      if (els.thumbnails.length) {
        els.thumbnails.forEach(function(thumb) {
          var isMatch = Number(thumb.dataset.imageId) === imageId;
          thumb.classList.toggle('is-active', isMatch);
          thumb.setAttribute('aria-current', isMatch ? 'true' : 'false');
          if (isMatch) scrollThumbIntoView(thumb);
        });
      }

      /* Scroll mobile slider to matching image */
      if (els.mobileSlider) {
        var slide = els.mobileSlider.querySelector('[data-image-id="' + imageId + '"]');
        if (slide) slide.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    }

    function scrollThumbIntoView(thumb) {
      var container = thumb.closest('[data-thumbnail-list]');
      if (!container) return;
      thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    /* -- Quantity +/- -- */
    var qtyMinus = section.querySelector('[data-qty-minus]');
    var qtyPlus = section.querySelector('[data-qty-plus]');

    if (qtyMinus) {
      qtyMinus.addEventListener('click', function() {
        if (!els.quantityInput) return;
        var val = parseInt(els.quantityInput.value, 10) || 1;
        if (val > 1) els.quantityInput.value = val - 1;
      });
    }
    if (qtyPlus) {
      qtyPlus.addEventListener('click', function() {
        if (!els.quantityInput) return;
        var val = parseInt(els.quantityInput.value, 10) || 1;
        els.quantityInput.value = val + 1;
      });
    }

    /* -- Add to cart (Fetch API) -- */
    if (els.form) {
      els.form.addEventListener('submit', function(e) {
        e.preventDefault();
        var variantId = els.variantId ? els.variantId.value : null;
        var quantity = els.quantityInput ? parseInt(els.quantityInput.value, 10) : 1;
        if (!variantId) return;

        els.addBtn.disabled = true;
        els.addBtn.classList.add('is-loading');

        shopifyFetch('/cart/add.js', {
          method: 'POST',
          body: JSON.stringify({
            items: [{ id: parseInt(variantId, 10), quantity: quantity }]
          })
        })
        .then(function() {
          return shopifyFetch('/cart.js');
        })
        .then(function(cart) {
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { items_count: cart.item_count }
          }));
          document.dispatchEvent(new CustomEvent('cart:added'));
        })
        .catch(function(err) {
          console.error('Add to cart error:', err);
        })
        .finally(function() {
          els.addBtn.disabled = false;
          els.addBtn.classList.remove('is-loading');
        });
      });
    }

    /* -- Bind option change events -- */
    els.optionInputs.forEach(function(input) {
      var eventType = input.tagName === 'SELECT' ? 'change' : 'change';
      input.addEventListener(eventType, onOptionChange);
    });

    /* -- Gallery: thumbnails click -- */
    els.thumbnails.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var src = thumb.dataset.fullSrc;
        var srcset = thumb.dataset.srcset;
        var alt = thumb.dataset.alt || '';
        if (els.mainImage && src) {
          els.mainImage.src = src;
          if (srcset) els.mainImage.srcset = srcset;
          els.mainImage.alt = alt;
        }
        els.thumbnails.forEach(function(t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-current', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-current', 'true');
      });

      /* Keyboard: Enter/Space */
      thumb.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          thumb.click();
        }
      });
    });

    /* -- Gallery: mobile swipe slider -- */
    if (els.mobileSlider) {
      initMobileSwipe(els.mobileSlider);
    }

    /* -- Gallery: zoom on click (desktop) -- */
    if (els.mainImage) {
      var zoomContainer = els.mainImage.closest('[data-zoom-container]');
      if (zoomContainer) {
        zoomContainer.addEventListener('click', function() {
          zoomContainer.classList.toggle('is-zoomed');
        });
        zoomContainer.addEventListener('mousemove', function(e) {
          if (!zoomContainer.classList.contains('is-zoomed')) return;
          var rect = zoomContainer.getBoundingClientRect();
          var x = ((e.clientX - rect.left) / rect.width) * 100;
          var y = ((e.clientY - rect.top) / rect.height) * 100;
          els.mainImage.style.transformOrigin = x + '% ' + y + '%';
        });
        zoomContainer.addEventListener('mouseleave', function() {
          zoomContainer.classList.remove('is-zoomed');
          els.mainImage.style.transformOrigin = '';
        });
      }
    }

    /* -- Init: select current variant from URL or first available -- */
    (function initVariant() {
      var params = new URLSearchParams(window.location.search);
      var variantParam = params.get('variant');
      var variant = null;

      if (variantParam) {
        variant = product.variants.find(function(v) {
          return v.id === parseInt(variantParam, 10);
        });
      }
      if (!variant) {
        variant = product.variants.find(function(v) { return v.available; }) || product.variants[0];
      }

      if (variant) {
        /* Set option inputs to match variant */
        variant.options.forEach(function(optValue, i) {
          var group = section.querySelector('[data-option-group][data-option-index="' + (i + 1) + '"]');
          if (!group) return;
          var input = group.querySelector('[data-option-input][value="' + CSS.escape(optValue) + '"]');
          if (input) {
            if (input.type === 'radio') input.checked = true;
            else if (input.tagName === 'SELECT') input.value = optValue;
          }
        });
        state.currentVariant = variant;
        updateVariantInput(variant);
        updatePrice(variant);
        updateAvailability(variant);
        updateSKU(variant);
      }
    })();

    /* -- Sticky add-to-cart bar (mobile) -- */
    var stickyBar = document.querySelector('[data-sticky-bar]');
    var stickyAddBtn = stickyBar ? stickyBar.querySelector('[data-sticky-add]') : null;

    if (stickyBar && els.addBtn) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { threshold: 0 });
      observer.observe(els.addBtn);

      if (stickyAddBtn) {
        stickyAddBtn.addEventListener('click', function() {
          if (els.form) els.form.requestSubmit();
        });
      }
    }
  }

  /* -- Mobile slider swipe -- */
  function initMobileSwipe(slider) {
    var startX = 0;
    var scrollLeft = 0;
    var isDragging = false;

    slider.addEventListener('touchstart', function(e) {
      isDragging = true;
      startX = e.touches[0].pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    }, { passive: true });

    slider.addEventListener('touchmove', function(e) {
      if (!isDragging) return;
      var x = e.touches[0].pageX - slider.offsetLeft;
      var walk = (x - startX) * 1.5;
      slider.scrollLeft = scrollLeft - walk;
    }, { passive: true });

    slider.addEventListener('touchend', function() {
      isDragging = false;
    }, { passive: true });
  }

  /* -- Helpers -- */
  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function getSizedImageUrl(src, size) {
    if (!src) return '';
    return src.replace(/(\.[^.]+)$/, '_' + size + '$1');
  }
})();


/* ---- Quick View ---- */

(function() {
  var modal = document.querySelector('[data-quick-view-modal]');
  if (!modal) return;

  var modalContent = modal.querySelector('[data-quick-view-content]');
  var closeBtn = modal.querySelector('[data-quick-view-close]');
  var releaseFocusFn = null;
  var triggerEl = null;

  /* Open */
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-quick-view-trigger]');
    if (!trigger) return;
    e.preventDefault();
    triggerEl = trigger;
    var productUrl = trigger.dataset.quickViewTrigger;
    if (!productUrl) return;
    openQuickView(productUrl);
  });

  function openQuickView(url) {
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    showOverlay();
    modalContent.innerHTML = '<div class="quick-view__loading"><span class="visually-hidden">' + (modal.dataset.loadingText || 'Cargando...') + '</span><div class="quick-view__spinner"></div></div>';

    fetch(url + '?sections=product-quick-view-data')
      .then(function(r) { return r.json(); })
      .catch(function() {
        /* Fallback: fetch the product URL with section rendering */
        return fetch(url + '.js').then(function(r) { return r.json(); });
      })
      .then(function(data) {
        renderQuickView(data, url);
      })
      .catch(function() {
        /* Final fallback: redirect */
        window.location.href = url;
      });
  }

  function renderQuickView(product, url) {
    var variant = product.variants ? (product.variants.find(function(v) { return v.available; }) || product.variants[0]) : null;
    if (!variant) { closeQuickView(); return; }

    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    var image = variant.featured_image || (product.images && product.images[0]) || {};
    var imageSrc = typeof image === 'string' ? image : (image.src || '');

    var html = '<div class="quick-view__product" data-product-section>';
    html += '<div class="quick-view__image-wrapper">';
    if (imageSrc) {
      html += '<img src="' + imageSrc + '" alt="' + escapeHtml(product.title) + '" class="quick-view__image" loading="eager">';
    }
    html += '</div>';
    html += '<div class="quick-view__info">';
    html += '<h2 class="quick-view__title">' + escapeHtml(product.title) + '</h2>';
    if (product.vendor) {
      html += '<p class="quick-view__vendor">' + escapeHtml(product.vendor) + '</p>';
    }

    /* Price */
    html += '<div class="quick-view__price">';
    if (onSale) {
      html += '<span class="quick-view__price-sale">' + formatMoneyQV(variant.price) + '</span>';
      html += '<s class="quick-view__price-compare">' + formatMoneyQV(variant.compare_at_price) + '</s>';
    } else {
      html += '<span class="quick-view__price-regular">' + formatMoneyQV(variant.price) + '</span>';
    }
    html += '</div>';

    /* Variant selector (if more than 1 variant) */
    if (product.variants && product.variants.length > 1 && product.options) {
      html += '<div class="quick-view__variants">';
      product.options.forEach(function(optionName, optIdx) {
        var values = [];
        product.variants.forEach(function(v) {
          var val = v.options[optIdx];
          if (values.indexOf(val) === -1) values.push(val);
        });
        html += '<div class="quick-view__option">';
        html += '<label class="quick-view__option-label">' + escapeHtml(optionName) + '</label>';
        html += '<select class="form-input quick-view__option-select" data-qv-option-index="' + optIdx + '">';
        values.forEach(function(val) {
          var selected = val === variant.options[optIdx] ? ' selected' : '';
          html += '<option value="' + escapeHtml(val) + '"' + selected + '>' + escapeHtml(val) + '</option>';
        });
        html += '</select>';
        html += '</div>';
      });
      html += '</div>';
    }

    /* Quantity + Add to cart */
    html += '<div class="quick-view__actions">';
    html += '<div class="quick-view__quantity">';
    html += '<button type="button" class="quick-view__qty-btn" data-qv-qty-minus aria-label="-">−</button>';
    html += '<input type="number" class="form-input quick-view__qty-input" value="1" min="1" data-qv-qty-input>';
    html += '<button type="button" class="quick-view__qty-btn" data-qv-qty-plus aria-label="+">+</button>';
    html += '</div>';
    html += '<button type="button" class="btn btn--primary quick-view__add-btn" data-qv-add';
    if (!variant.available) html += ' disabled';
    html += ' data-variant-id="' + variant.id + '">';
    html += variant.available ? (modal.dataset.addText || 'Agregar al carrito') : (modal.dataset.soldOutText || 'Agotado');
    html += '</button>';
    html += '</div>';

    /* View full details link */
    html += '<a href="' + url + '" class="quick-view__view-full">' + (modal.dataset.viewFullText || 'Ver detalles completos') + '</a>';

    html += '</div>'; /* .quick-view__info */
    html += '</div>'; /* .quick-view__product */

    modalContent.innerHTML = html;

    /* Bind quick view events */
    bindQuickViewEvents(product, variant);

    releaseFocusFn = trapFocus(modal);
  }

  function bindQuickViewEvents(product, currentVariant) {
    /* Variant selects */
    var selects = modal.querySelectorAll('[data-qv-option-index]');
    selects.forEach(function(sel) {
      sel.addEventListener('change', function() {
        var options = [];
        selects.forEach(function(s) { options.push(s.value); });
        var variant = product.variants.find(function(v) {
          return v.options.every(function(opt, i) { return opt === options[i]; });
        });
        if (variant) {
          currentVariant = variant;
          /* Update price */
          var priceEl = modal.querySelector('.quick-view__price');
          if (priceEl) {
            var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
            if (onSale) {
              priceEl.innerHTML = '<span class="quick-view__price-sale">' + formatMoneyQV(variant.price) + '</span><s class="quick-view__price-compare">' + formatMoneyQV(variant.compare_at_price) + '</s>';
            } else {
              priceEl.innerHTML = '<span class="quick-view__price-regular">' + formatMoneyQV(variant.price) + '</span>';
            }
          }
          /* Update image */
          var img = modal.querySelector('.quick-view__image');
          if (img && variant.featured_image) {
            img.src = variant.featured_image.src || variant.featured_image;
          }
          /* Update add button */
          var addBtn = modal.querySelector('[data-qv-add]');
          if (addBtn) {
            addBtn.disabled = !variant.available;
            addBtn.textContent = variant.available ? (modal.dataset.addText || 'Agregar al carrito') : (modal.dataset.soldOutText || 'Agotado');
            addBtn.dataset.variantId = variant.id;
          }
        }
      });
    });

    /* Quantity */
    var qtyInput = modal.querySelector('[data-qv-qty-input]');
    var qtyMinus = modal.querySelector('[data-qv-qty-minus]');
    var qtyPlus = modal.querySelector('[data-qv-qty-plus]');
    if (qtyMinus) qtyMinus.addEventListener('click', function() {
      var v = parseInt(qtyInput.value, 10) || 1;
      if (v > 1) qtyInput.value = v - 1;
    });
    if (qtyPlus) qtyPlus.addEventListener('click', function() {
      var v = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = v + 1;
    });

    /* Add to cart */
    var addBtn = modal.querySelector('[data-qv-add]');
    if (addBtn) {
      addBtn.addEventListener('click', function() {
        var variantId = parseInt(addBtn.dataset.variantId, 10);
        var qty = parseInt(qtyInput ? qtyInput.value : 1, 10);
        addBtn.disabled = true;
        addBtn.classList.add('is-loading');

        shopifyFetch('/cart/add.js', {
          method: 'POST',
          body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
        })
        .then(function() { return shopifyFetch('/cart.js'); })
        .then(function(cart) {
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { items_count: cart.item_count }
          }));
          addBtn.textContent = modal.dataset.addedText || 'Agregado';
          setTimeout(function() {
            closeQuickView();
            document.dispatchEvent(new CustomEvent('cart:added'));
          }, 1200);
        })
        .catch(function(err) {
          console.error('Quick view add error:', err);
        })
        .finally(function() {
          addBtn.disabled = false;
          addBtn.classList.remove('is-loading');
        });
      });
    }
  }

  /* Close */
  function closeQuickView() {
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    hideOverlay();
    if (releaseFocusFn) { releaseFocusFn(); releaseFocusFn = null; }
    if (triggerEl) { triggerEl.focus(); triggerEl = null; }
    modalContent.innerHTML = '';
  }

  if (closeBtn) closeBtn.addEventListener('click', closeQuickView);

  modal.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeQuickView();
  });

  /* Click outside content closes */
  modal.addEventListener('click', function(e) {
    if (e.target === modal) closeQuickView();
  });

  document.addEventListener('drawer:close', closeQuickView);

  /* Helpers */
  function formatMoneyQV(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function escapeHtml(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }
})();
